<script lang="ts" setup>
import { I18nKey } from '@/utils/typings';
import EvaluationsQuantityTile from './EvaluationsQuantityTile.vue';
import InlineValidationError from '@/components/forms/InlineValidationError/InlineValidationError.vue';
import ValidationIndicator from '@/components/forms/ValidationIndicator/ValidationIndicator.vue';

import { EvaluationParameterScopeDto } from '@/api/generator';
import { useField, useValidateField } from 'vee-validate';
import { computed, toRef } from 'vue';

const { name } = defineProps<{
  name: string; // taskItemAreas[${areaIndex}].evaluationScopes[{scopeIndex}]
}>();

const { value: scope } = useField<EvaluationParameterScopeDto>(toRef(() => name));

const evaluationParametersPath = computed(() => `${name}.evaluationParameters`);

const validate = useValidateField(evaluationParametersPath);
</script>

<template>
  <v-expansion-panel>
    <v-expansion-panel-title>
      <h6>
        <ValidationIndicator :paths="[name]">
          {{ $t(`EvaluationLabel.${scope.evaluationScopeCategory}` as I18nKey) }}
        </ValidationIndicator>
      </h6>
    </v-expansion-panel-title>

    <v-expansion-panel-text>
      <InlineValidationError ignoreTouched :name="evaluationParametersPath" class="mb-2 mt-1" />
      <!-- nested panels -->
      <v-expansion-panels multiple :rounded="true" class="ga-2">
        <EvaluationsQuantityTile
          v-for="(_item, index) in scope.evaluationParameters"
          :key="index"
          :name="`${name}.evaluationParameters[${index}]`"
          :showInBeamConstancyCheck="true"
          class="w-100"
          @select="validate"
        />
      </v-expansion-panels>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>
